var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { attrs: { id: "packs" } },
    [
      _c("h2", { staticClass: "sr-only" }, [_vm._v("Icon Packs")]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "row roomy laptop:align-middle margin-bottom-xl",
          staticStyle: {
            "--button-background": "transparent",
            "--button-hover-background": "transparent",
            "--button-hover-color": "var(--fa-dk-blue)",
            "--button-margin-bottom": "0",
            "--link-color": "var(--fa-navy)",
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "column-12 laptop:column-9 display-flex flex-items-center flex-wrap margin-bottom-md laptop:margin-bottom-0",
              staticStyle: {
                "--button-border-radius": "var(--border-radius-pill)",
                gap: "var(--spacing-sm)",
              },
            },
            [
              _c("h3", { staticClass: "sr-only" }, [
                _vm._v("Filter Icon Packs by Icon Types"),
              ]),
              _vm._v(" "),
              _vm._l(_vm.visualTags, function (tag, index) {
                return _c(
                  "button",
                  {
                    key: index,
                    staticClass:
                      "size-sm padding-y-sm action-scale packs-type-filter-button",
                    style: {
                      "--button-box-shadow": "none",
                      "--button-box-shadow-width": "0",
                      "--button-border-color": _vm.isIconVisualTagSelected(
                        tag.label
                      )
                        ? "var(--fa-dk-blue)"
                        : "var(--fa-gravy)",
                      "--button-color": _vm.isIconVisualTagSelected(tag.label)
                        ? "var(--fa-dk-blue)"
                        : "initial",
                    },
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.toggleIconVisualTag(tag.label)
                      },
                    },
                  },
                  [
                    _c("i", {
                      class: `${tag.icon} fa-lg fa-fw margin-right-3xs`,
                    }),
                    _vm._v("\n        " + _vm._s(tag.label) + "\n      "),
                  ]
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "column-12 laptop:column-3 display-flex flex-items-center laptop:flex-content-end",
            },
            [
              _c("h3", { staticClass: "sr-only" }, [_vm._v("Sort Icon Packs")]),
              _vm._v(" "),
              _vm._l(_vm.sortOptions, function (option, index) {
                return _c(
                  "button",
                  {
                    key: index,
                    staticClass: "size-sm flat compact action-scale",
                    style: {
                      "--button-border-color": _vm.isSortOptionActive(
                        option.label
                      )
                        ? "var(--fa-dk-blue)"
                        : "transparent",
                      "--button-color": _vm.isSortOptionActive(option.label)
                        ? "var(--fa-dk-blue)"
                        : "initial",
                    },
                    attrs: {
                      type: "button",
                      "aria-label": option.label,
                      "data-balloon-pos": "up",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.setSortOption(option.label)
                      },
                    },
                  },
                  [
                    _c("font-awesome-icon", {
                      attrs: {
                        icon: _vm.$v6[option.iconStyle || "solid"][
                          option.iconName
                        ],
                        "fixed-width": "",
                        size: "lg",
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v(_vm._s(option.label)),
                    ]),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "transition-group",
        {
          staticClass: "packs-listing",
          attrs: { name: "pack-transition", tag: "div" },
        },
        _vm._l(_vm.filteredIconPacks, function (pack, index) {
          return _c("pack-card", {
            key: pack.name,
            attrs: {
              "icon-pack": pack,
              "family-styles": pack.filteredFamilyStyles,
              "is-last": _vm.filteredIconPacks.length === index + 1,
            },
          })
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "article",
        {
          staticClass: "card muted roomy margin-top-2xl",
          staticStyle: {
            "--card-background": "transparent",
            "--card-border-color": "var(--fa-gravy)",
            "--card-border-width": "var(--border-width-sm)",
            "--card-border-style": "dashed",
          },
        },
        [
          _c("wa-question-mark-block", {
            attrs: {
              "block-color": "var(--text-color)",
              "block-hover-primary-color": "var(--fa-navy)",
              "block-size": "3x",
            },
          }),
          _vm._v(" "),
          _c("p", { staticClass: "margin-top-md" }, [
            _vm._v("New Icon Packs Coming Soon!"),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }